/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerSystemLocalizedTextDto } from '../models/EntityModelResponseContainerSystemLocalizedTextDto';
import type { PagedModelEntityModelSystemLocalizedTextDto } from '../models/PagedModelEntityModelSystemLocalizedTextDto';
import type { PagedResourcesAssemblerSystemLocalizedTextDto } from '../models/PagedResourcesAssemblerSystemLocalizedTextDto';
import type { ProgramLocalizedTextDto } from '../models/ProgramLocalizedTextDto';
import type { SystemLocalizedTextDto } from '../models/SystemLocalizedTextDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemLocalizedTextControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static createOrUpdateBulkAdmin({
        requestBody,
    }: {
        requestBody: Array<ProgramLocalizedTextDto>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/localizedTextsBulkUpdateAdmin',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelSystemLocalizedTextDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerSystemLocalizedTextDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelSystemLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/texts',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        languageCode,
        messageKey,
    }: {
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerSystemLocalizedTextDto OK
     * @throws ApiError
     */
    public static read({
        languageCode,
        messageKey,
    }: {
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<EntityModelResponseContainerSystemLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerSystemLocalizedTextDto OK
     * @throws ApiError
     */
    public static create({
        languageCode,
        messageKey,
        requestBody,
    }: {
        languageCode: string,
        messageKey: string,
        requestBody: SystemLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerSystemLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerSystemLocalizedTextDto OK
     * @throws ApiError
     */
    public static update({
        languageCode,
        messageKey,
        requestBody,
    }: {
        languageCode: string,
        messageKey: string,
        requestBody: SystemLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerSystemLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
